import { 
    useLocation,
    Routes,
    Route,
    Navigate,
} from "react-router-dom"; 
import { withPather } from 'react-pather';
import * as Components from './Components';
import PrivateRoute from "./PrivateRoute";
import { PageLayout, seo } from "../seo";

const SystemRouteComponent = ({ seoConfig, path, comp }) => (
    <PageLayout path={path} {...seoConfig}>
        {comp}
    </PageLayout>
);

const TrailingSlashRedirect = () => {
    const location = useLocation();
    if (location.pathname.endsWith("/") && location.pathname !== "/") {
        const pathWithoutSlash = location.pathname.slice(0, -1);
        return <Navigate to={pathWithoutSlash + location.search} replace />;
    }
    return null;
}

const SystemRoutes = ({ pather }) => {
    return (
        <>
            {/* Redirect all routes with trailing slash to no-trailing slash routes. */}
            <TrailingSlashRedirect /> 

            <Routes>
                {/* Public Indexable Routes */}
                <Route path="/" element={
                        <SystemRouteComponent 
                            seoConfig={seo.home} 
                            path=""
                            comp={<Components.Home/>} 
                        />
                    } 
                />
                <Route path={pather.front.shorten} element={
                        <SystemRouteComponent 
                            seoConfig={seo.shorten} 
                            path={pather.front.shorten}
                            comp={<Components.Shorten/>} 
                        />
                    } 
                />
                <Route path={pather.front.login} element={
                        <SystemRouteComponent 
                            seoConfig={seo.login} 
                            path={pather.front.login}
                            comp={<Components.Login/>} 
                        />
                    } 
                />
                <Route path={pather.front.signup} element={
                        <SystemRouteComponent 
                            seoConfig={seo.signup} 
                            path={pather.front.signup}
                            comp={<Components.SignUp/>} 
                        />
                    } 
                />
                <Route path={pather.front.resetPassword} element={
                        <SystemRouteComponent 
                            seoConfig={seo.resetPassword} 
                            path={pather.front.resetPassword}
                            comp={<Components.ResetPassword/>} 
                        />
                    } 
                />
                <Route path={pather.front.privacy} element={
                        <SystemRouteComponent 
                            seoConfig={seo.privacy} 
                            path={pather.front.privacy}
                            comp={<Components.PrivacyPolicy/>} 
                        />
                    } 
                />
                <Route path={pather.front.termsConditions} element={
                        <SystemRouteComponent 
                            seoConfig={seo.terms} 
                            path={pather.front.termsConditions}
                            comp={<Components.TermsConditions/>} 
                        />
                    } 
                />
                <Route path={pather.front.checkSubmit} element={
                        <SystemRouteComponent
                            seoConfig={seo.checkSubmit} 
                            path={pather.front.checkSubmit}
                            comp={<Components.CheckSubmit/>} 
                        />
                    } 
                />

                {/* Public Non-Indexable Routes */}
                <Route path={pather.front.main} element={
                        <SystemRouteComponent 
                            seoConfig={seo.redirect} 
                            comp={<Components.Redirect/>} 
                        />
                    } 
                />
                <Route path={pather.front.confirmAccount} element={
                        <SystemRouteComponent 
                            seoConfig={seo.confirmAccount} 
                            comp={<Components.ConfirmAccount/>} 
                        />
                    } 
                />
                <Route path={pather.front.reset} element={
                        <SystemRouteComponent 
                            seoConfig={seo.reset} 
                            comp={<Components.Reset/>} 
                        />
                    } 
                />
                <Route path={pather.front.check} element={
                        <SystemRouteComponent 
                            seoConfig={seo.check} 
                            comp={<Components.Check/>} 
                        />
                    } 
                />

                {/* Private Routes */}
                <Route element={<PrivateRoute />}>
                    <Route path={pather.front.dashboard} element={
                            <SystemRouteComponent 
                                seoConfig={seo.dashboard} 
                                comp={<Components.Dashboard/>} 
                            />
                        } 
                    />
                    <Route path={pather.front.view} element={
                            <SystemRouteComponent 
                                seoConfig={seo.conversionView} 
                                comp={<Components.ConversionView/>} 
                            />
                        } 
                    />
                    <Route path={pather.front.settings} element={
                            <SystemRouteComponent 
                                seoConfig={seo.settings} 
                                comp={<Components.Settings/>} 
                            />
                        } 
                    />
                    <Route path={pather.front.redirects} element={
                            <SystemRouteComponent 
                                seoConfig={seo.redirects} 
                                comp={<Components.Redirects/>} 
                            />
                        } 
                    />
                    <Route path={pather.front.tags} element={
                            <SystemRouteComponent 
                                seoConfig={seo.tags} 
                                comp={<Components.Tags/>} 
                            />
                        } 
                    />
                </Route>

                {/* 404 */}
                <Route path="*" element={
                        <SystemRouteComponent 
                            seoConfig={seo.notFound} 
                            comp={<Components.PageNotFound/>} 
                        />
                    } 
                />
            </Routes>
        </>
    );
}

export default withPather()(SystemRoutes);